import { useState } from 'react';
import { PlusIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

/** グループ名の上限（BE はタブ名と同じ規則で検証する）。 */
const MAX_GROUP_NAME_CHARS = 120;

export interface AddTabGroupFormProps {
  disabled: boolean;
  /** 追加できたら true を返す（入力欄を空に戻す）。 */
  onSubmit: (name: string) => Promise<boolean>;
}

/** タブグループ名を入力して、表示末尾にグループを追加するフォーム。 */
export function AddTabGroupForm({ disabled, onSubmit }: AddTabGroupFormProps) {
  const [name, setName] = useState('');
  const trimmed = name.trim();
  const isTooLong = [...trimmed].length > MAX_GROUP_NAME_CHARS;
  const canSubmit = trimmed.length > 0 && !isTooLong && !disabled;

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!canSubmit) return;
    if (await onSubmit(trimmed)) setName('');
  };

  return (
    <form
      className="flex flex-wrap items-center gap-2 rounded-xl border border-dashed px-5 py-4"
      onSubmit={(event) => void handleSubmit(event)}
    >
      <Input
        aria-label="新しいタブグループ名"
        className="h-9 max-w-xs"
        placeholder="タブグループ名"
        value={name}
        onChange={(event) => setName(event.target.value)}
      />
      <Button type="submit" variant="outline" disabled={!canSubmit}>
        <PlusIcon size={16} aria-hidden />
        タブグループを追加
      </Button>
      {isTooLong && (
        <p className="text-sm text-destructive">
          タブグループ名は {MAX_GROUP_NAME_CHARS} 文字以下で入力してください
        </p>
      )}
    </form>
  );
}
